import { ImageScaleView, MovieClip } from '@play-co/timestep-core/ui';
import { ButtonScaleViewOpts } from 'src/lib/ui/components/ButtonScaleView';
import { getDailyBonusTimerText, isDailyBonusReady } from '../match2.util';
import StateObserver, { user } from 'src/StateObserver';
import { AssetGroup } from '@play-co/timestep-core';
import { FeatureButton } from 'src/game/components/FeatureButton';
import { isMatch2DailyBonusActive } from 'src/replicant/match2/match2.getters';

const assets = {
  movieclip: {
    url: 'assets/ui/match2/daily_bonus/button',
    loadMethod: MovieClip.animationLoader,
  },
  grey: 'assets/ui/match2/daily_bonus/button_grey.png',
  title_en: 'assets/ui/match2/daily_bonus/title_en.png',
  title_ja: 'assets/ui/match2/daily_bonus/title_ja.png',
  panelBgGreen: 'assets/ui/shared/frames/timer_bg_green.png',
  panelBgWhite: 'assets/ui/shared/frames/timer_bg_white.png',
};

type AnimationState = 'available' | 'unavailable';

export class DailyBonusButtonAnimated extends FeatureButton<AnimationState> {
  private grey: ImageScaleView;
  private title: ImageScaleView;

  constructor(opts: ButtonScaleViewOpts) {
    const width = 146;
    const height = 159;

    super({
      width,
      height,
      pressedOffsetY: 5,
      labelPanel: {
        offsetY: 5,
        labelOffsetY: -3,
        background: {
          image: assets.panelBgGreen,
        },
      },
      ...opts,
    });

    this.animationStateMap = {
      available: {
        type: 'movieclip',
        assetGroup: new AssetGroup(Object.values(assets)),
        url: assets.movieclip.url,
        sequence: ['daily_bonus_spawn', 'daily_bonus_loop'],
        scale: 0.65,
      },
      unavailable: {
        // This will display the grey static image only
        type: 'custom',
        assetGroup: new AssetGroup([
          assets.grey,
          assets.title_en,
          assets.title_ja,
          assets.panelBgWhite,
        ]),
      },
    };

    this.grey = new ImageScaleView({
      superview: this.container,
      x: this.style.width * 0.5,
      y: this.style.height * 0.5,
      width: 144,
      height: 150,
      centerOnOrigin: true,
      scaleMethod: 'contain',
    });

    this.title = new ImageScaleView({
      superview: this.container,
      x: this.style.width * 0.5,
      y: 105,
      width: 111,
      height: 53,
      centerOnOrigin: true,
      scaleMethod: 'contain',
    });

    // Trigger update to initialize the button state immediately.
    this.update();
  }

  public update() {
    // Button should be hidden while daily bonus is not active
    if (!isMatch2DailyBonusActive(user())) {
      this.hide();
      return;
    }

    this.show();

    if (isDailyBonusReady()) {
      this.grey.updateOpts({ visible: false });
      this.setAnimationState('available');
    } else {
      this.grey.updateOpts({ image: assets.grey, visible: true });
      this.setAnimationState('unavailable');
    }

    const locale = StateObserver.getLocale();
    this.title.updateOpts({
      image: assets[`title_${locale}`],
    });

    const bonusReady = isDailyBonusReady();
    this.updateLabelPanel({
      localeText: () => getDailyBonusTimerText(),
      background: {
        image: bonusReady ? assets.panelBgGreen : assets.panelBgWhite,
      },
      labelColor: bonusReady ? '#FFFFFF' : '#783B3D',
    });
  }
}
